module.exports = __webpack_public_path__ + "static/media/Aveny soffa 3-sits med divan brooksville soffbord miljö 2023 1.cbc814a2.jpg";